class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Close after, in seconds
    this.closeAfter = Number(this.dataset.autoclose) || 0; 

    this.updateHoverBehavior();
  }

  updateHoverBehavior() {
    // Remove previous listeners
    this.mainDetailsToggle.removeEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.removeEventListener('mouseleave', this.close.bind(this));

    // Add new listeners only if hover is enabled and is desktop
    if (this.isHoverEnabled && window.matchMedia('(min-width: 1024px)').matches) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));
    }
  }

  get isHoverEnabled() {
    return this.hasAttribute('data-hover-enabled');
  }

  static get observedAttributes() {
    return ['data-hover-enabled'];
  }

  attributeChangedCallback(name) {
    if (name === 'data-hover-enabled') {
      this.updateHoverBehavior();
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      this.runCloseAfter();
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  runCloseAfter() {
    const currentlyHovered = this.isHoverEnabled && window.matchMedia('(min-width: 1024px)').matches && this.mainDetailsToggle.matches(':hover');

    if (this.closeAfter > 0 && !currentlyHovered) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        };
      }, this.closeAfter * 1000);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


class CustomTooltip extends DetailsDisclosure {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.tooltipContent = this.querySelector('.tooltip-content');

    this.mainDetailsToggle.addEventListener('toggle', () => {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.setPosition();
      }
    });
  }

  setPosition() {
    this.tooltipContent.style.top = '';
    this.tooltipContent.style.left = '';
    this.tooltipContent.style.setProperty('--tooltip-arrow-left', '');

    // Check if tool tip is overflowing the viewport
    const tooltipRect = this.tooltipContent.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const overflowRight = tooltipRect.right > viewportWidth;
    const overflowBottom = tooltipRect.bottom > viewportHeight;
    const overflowLeft = tooltipRect.left < 0;
    const overflowTop = tooltipRect.top < 0;

    if (overflowRight) {
      this.tooltipContent.style.left = `${viewportWidth - tooltipRect.width}px`;
    } else if (overflowLeft) {
      this.tooltipContent.style.left = `${tooltipRect.width / 2}px`;
      this.tooltipContent.style.setProperty('--tooltip-arrow-left', '15%');
    }
    if (overflowBottom) {
      this.tooltipContent.style.top = `${viewportHeight - tooltipRect.height}px`;
    } else if (overflowTop) {
      this.tooltipContent.style.top = '0px';
    }
  }
}

customElements.define('custom-tooltip', CustomTooltip);
